import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CommonValues from "../Common/utils";

interface ChatMessage {
  question: string;
  answer: string;
  documents?: string[];
  chatId?: string;
  sources?: string[];
  conversationId?: string;
}

interface BaseChatProps {
  onSendMessage: (message: string) => Promise<void>;
  fetchChatHistory?: (conversationId: string) => Promise<void>;
  promptCards: Array<{
    label: string;
    title: string;
  }>;
}

export type { ChatMessage };

export const useBaseChatLogic = () => {
  const [showQuestionAnswerBlock, setShowQuestionAnswerBlock] = useState(false);
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [conversationId, setConversationId] = useState<string>("");
  const { conversationId: paramConversationId } = useParams<{
    conversationId: string;
  }>();
  const navigate = useNavigate();

  useEffect(() => {
    setConversationId(crypto.randomUUID());
  }, []);

  const handleFollowUpQuestion = (question: string, onSendMessage: (message: string) => Promise<void>) =>
    onSendMessage(question);

  const handlePromptClick = (promptText: string, onSendMessage: (message: string) => Promise<void>) => {
    onSendMessage(promptText);
    setShowQuestionAnswerBlock(true);
  };

  return {
    showQuestionAnswerBlock,
    setShowQuestionAnswerBlock,
    messages,
    setMessages,
    isLoading,
    setIsLoading,
    conversationId,
    setConversationId,
    paramConversationId,
    navigate,
    handleFollowUpQuestion,
    handlePromptClick,
  };
};